export default {
  namespaced: true,
  state: {
    // weixin
    code: null,
    sid: null,

    // ranch
    user: null,

    // dartcome
    me: null,

    addTimerJob: []
  },
  mutations: {
    code (state, payload) { state.code = payload },
    sid (state, payload) { state.sid = payload },
    user (state, payload) { state.user = payload },
    me (state, payload) { state.me = payload }
  }
}



// WEBPACK FOOTER //
// ./src/store/me/index.js